var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToasterError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6085_24153)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 27,
    r: 18,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1331 30.267L32.7997 20.667C32.0831 19.3753 31.0914 18.667 29.9997 18.667C28.9081 18.667 27.9164 19.3753 27.1997 20.667L21.8664 30.267C21.1914 31.492 21.1164 32.667 21.6581 33.592C22.1997 34.517 23.2664 35.0253 24.6664 35.0253H35.3331C36.7331 35.0253 37.7997 34.517 38.3414 33.592C38.8831 32.667 38.8081 31.4837 38.1331 30.267ZM29.3747 24.5003C29.3747 24.1587 29.6581 23.8753 29.9997 23.8753C30.3414 23.8753 30.6247 24.1587 30.6247 24.5003V28.667C30.6247 29.0087 30.3414 29.292 29.9997 29.292C29.6581 29.292 29.3747 29.0087 29.3747 28.667V24.5003ZM30.5914 31.7587C30.5497 31.792 30.5081 31.8253 30.4664 31.8587C30.4164 31.892 30.3664 31.917 30.3164 31.9337C30.2664 31.9587 30.2164 31.9753 30.1581 31.9837C30.1081 31.992 30.0497 32.0003 29.9997 32.0003C29.9497 32.0003 29.8914 31.992 29.8331 31.9837C29.7831 31.9753 29.7331 31.9587 29.6831 31.9337C29.6331 31.917 29.5831 31.892 29.5331 31.8587C29.4914 31.8253 29.4497 31.792 29.4081 31.7587C29.2581 31.6003 29.1664 31.3837 29.1664 31.167C29.1664 30.9503 29.2581 30.7337 29.4081 30.5753C29.4497 30.542 29.4914 30.5087 29.5331 30.4753C29.5831 30.442 29.6331 30.417 29.6831 30.4003C29.7331 30.3753 29.7831 30.3587 29.8331 30.3503C29.9414 30.3253 30.0581 30.3253 30.1581 30.3503C30.2164 30.3587 30.2664 30.3753 30.3164 30.4003C30.3664 30.417 30.4164 30.442 30.4664 30.4753C30.5081 30.5087 30.5497 30.542 30.5914 30.5753C30.7414 30.7337 30.8331 30.9503 30.8331 31.167C30.8331 31.3837 30.7414 31.6003 30.5914 31.7587Z",
    fill: "#E72E55"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6085_24153",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6085_24153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6085_24153",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterError);
export default __webpack_public_path__ + "static/media/toasterError.1d3ee72350716df86cce79bcf7362217.svg";
export { ForwardRef as ReactComponent };